/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What kind of problem the user reports.
 * @export
 */
export const UserReportCategory = {
    Bug: 'bug',
    Content: 'content',
    Suggestion: 'suggestion',
    Other: 'other'
} as const;
export type UserReportCategory = typeof UserReportCategory[keyof typeof UserReportCategory];


export function instanceOfUserReportCategory(value: any): boolean {
    for (const key in UserReportCategory) {
        if (Object.prototype.hasOwnProperty.call(UserReportCategory, key)) {
            if (UserReportCategory[key as keyof typeof UserReportCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserReportCategoryFromJSON(json: any): UserReportCategory {
    return UserReportCategoryFromJSONTyped(json, false);
}

export function UserReportCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReportCategory {
    return json as UserReportCategory;
}

export function UserReportCategoryToJSON(value?: UserReportCategory | null): any {
    return value as any;
}

export function UserReportCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): UserReportCategory {
    return value as UserReportCategory;
}

